import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'

export const IdentifierBox = styled(Box)<{ background: string }>`
  border-radius: 2px;
  background: ${({ background }) => background};
  width: 12px;
  height: 12px;
`
